import { RadioButtonFilter } from '@lifebit-ai/lds'
import { ValidationStatuses } from 'enums'
import React from 'react'

import { Option } from 'modules/types'

interface ValidationStatusFilterProps {
  onApply: (filteredOption: Option | null) => void
  onReset: () => void
}

const options = [
  {
    label: 'Verified',
    value: ValidationStatuses.Verified
  },
  {
    label: 'Not checked',
    value: ValidationStatuses.NotChecked
  },
  {
    label: 'Auto-check in progress',
    value: ValidationStatuses.AutoCheckInProgress
  },
  {
    label: 'Auto-check passed',
    value: ValidationStatuses.AutoCheckPassed
  },
  {
    label: 'Auto-check failed',
    value: ValidationStatuses.AutoCheckFailed
  }
]

export const ValidationStatusFilter: React.FC<ValidationStatusFilterProps> = ({ onApply, onReset }) => {
  return (
    <RadioButtonFilter
      options={options}
      onApply={filteredOption => onApply(filteredOption ?? null)}
      onReset={onReset}
      label="Validation status"
      withFuzzySearch={false}
    />
  )
}
